/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import _ from 'lodash';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxComponent from '../../../SharedModules/SelectBox/SelectBox';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import CustomButton from './component/buttonDyn';
import { labelerTableHead, NDCTableHead } from './component/tableHead';
import {
  checkNDCAndAddToDetailsTable,
  searchNDCByIDORDrugName,
  setNDCErrorPopupMessage,
  getLabelerList,
  removeFromNDCDetailsTableData,
  getCommonDropdownList,
  getNDCByLabeller,
  requestRunNow,
  dispatchRequestClaim,
  requestClaimFields,
  setLeftTableData,
  setMoveAllDatasLefttoRight,
  setMoveAllDatasRighttoLeft,
  setRightTableData,
  requestClaimErrors,
} from './store/action';
import TableComponent from './component/TableComponent';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import {
  REBATE_SELECT,
  VALID_NDC_MSG_UC,
  QUARTER_FORMAT_ERROR,
  NDC_ALREADY_ADDED,
  MINIMUM_FORM_DATE,
  MINIMUM_START_DATE_VALUE,
  REQUEST_DATE_INVALID_FORMAT,
  TO_DATE_CANT_BE_LESS_THAN_FROM,
  NO_DATA_FOUND_ERROR,
  ERRORMESSAGE_NDC_NOT_EMPTY,
  ERRMSG_NO_NDC_REQUEST_CLAIM_AUDIT,
  ERRMSG_NOT_SELECTED_LABELER,
  ERR_SELECT_NDC_REMOVE,
  ERR_NDC_REMOVE,
  PAID_DATE_ERR,
  TO_QTR_CANT_BE_LESS_THAN_FROM,
  NDC_CODE_FOR_STC_NOT,
  NDC_FOR_UC_NOT,
  NDC_NOT_FOUND_STC,
  API_TIMEOUT_ERROR,
  NDC_LIMIT_TO_1000
} from '../../../SharedModules/Errors/constantMessageData';
import { DateRangeValidation } from '../../../SharedModules/DateRangeValiation.js';
import {
  handleScrollToEvent,
  isCheckDateFormat,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import { autoFormateDate } from '../../../SharedModules/utilities/utilities';
import { validateDateQuarter } from '../../../SharedModules/utilities/dateUtilities';
import CommonModal from '../../../SharedModules/Dialog/CommonModal';
const RequestClaimAudit = () => {
  const dispatch = useDispatch();
  const childRef = React.useRef(null);
  const userDefaults = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const {
    dropdown,
    ndcListFromLabeller,
    addRequestClaim,
    getRequestFieldsValue,
    leftNdcTable,
    rightNdcTable,
    getRequestFieldsErrors,
    duplicateErrors,
  } = useSelector((state) => state?.sharedState?.RequestClaimReducer);
  const [ndcSearchCode, setNdcSearchCode] = React.useState([]);
  const [ndcSearchError, setNdcSearchError] = React.useState([]);
  const [confirmAction, setConfirmAction] = React.useState(false);
  const [pendingPayload, setPendingPayload] = React.useState(null);
  const [filterValue, setFilterValue] = React.useState({
    clearPriorAuditsResult: 'Yes',
    planType: 'Medicaid',
    rebateProgram: -1,
    searchType: 'Name',
    selectBy: 'NDC',
    fromDate: '',
    toDate: '',
  });

  const [ndcsSearch, setNdcsSearch] = React.useState({
    ndcCode: '',
  });
  const [labelerData, setLabelerData] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState([]);
  const [ndcTableData, setNdcTableData] = React.useState([]);
  const [gridApi, setGridApi] = React.useState(null);
  const [gridApis, setGridApis] = React.useState(null);
  const [gridApiLab, setGridApiLab] = React.useState(null);
  const [labelerState, setLabelerState] = React.useState(true);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const existingLabelerDataFromAPI = useSelector(
    (state) => state?.sharedState?.RequestClaimReducer?.labelerList
  );

  const [successMessages, setSuccessMessages] = React.useState([]);
  const [radioList, setRadioList] = React.useState([
    'selectBy',
    'planType',
    'clearPriorAuditsResult',
    'searchType',
  ]);
  const [gridRef, setGridRef] = React.useState([]);
  const [existingLabelerData, setExistingLabelerData] = React.useState([]);
  const [addListedNdc, setAddListedNdc] = React.useState([]);
  const [labelerSelected, setLabelerSelected] = React.useState(null);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [fullScreenViewTable, setFullScreenViewTable] = React.useState(null);
  const [applyFilter, setApplyFilter] = React.useState(false);
  const [enableFilterCount, setEnableFilterCount] = React.useState(false);
  const [errorMessageForNDC1, seterrorMessageForNDC1] = React.useState([]);
  const [flag, setFlag] = React.useState(false);
  const [emptyTableError, setEmptyTableError] = React.useState({
    labelerTable: [],
    ndcLeft: [],
    ndcRight: [],
  });
  const [loading, setLoading] = React.useState(false);
  const logInUserID = useSelector((state) => state.sharedState.logInUserID);
  const [formError, setFormError] = React.useState({
    fromDate: false,
    toDate: false,
  });
  const [formErrMsg, setFormErrMsg] = React.useState({
    fromDate: '',
    toDate: '',
  });
  const [ndcValidError, setNdcValidError] = React.useState([]);
  const [rebateProgList, setRebateProgList] = React.useState([]);
  let viewFilter;

  const filterList = [
    {
      field: 'clearPriorAuditsResult',
      name: 'Clear Prior Audits Result',
      viewType: 'Radio',
      isEmp: true,
      list: [
        { name: 'Yes', value: 'Yes' },
        { name: 'No', value: 'No' },
      ],
      column: 3,
      column1: 6,
      column2: 3,
      columnlg_8: 8,
      columnxl_3: 3,
      columnmd_8: 8,
    },
    {
      field: 'planType',
      name: 'Plan Type',
      viewType: 'Radio',
      isEmp: true,
      list: [
        { name: 'Medicaid', value: 'Medicaid', sortValue: 'FD' },
        { name: 'State', value: 'State', sortValue: 'ST' },
        { name: 'Commercial', value: 'Commercial', sortValue: 'COMM' },
      ],
      column: 6,
      column2: 5,
      columnlg_6: 6,
      columnxl_5: 5,
      columnmd_6: 6,
    },
    {
      field: 'rebateProgram',
      name: 'Rebate Program',
      viewType: 'SelectBox',
      isEmp: true,
      list: [{ id: 1, name: 'BCCDT  Maryland BCCDT' }],
      // column: 4,
      column: 12,
      column1: 6,
      column2: 4,

      sm_pl0: 0,
      md_pl3: 3,
      lg_pl3: 3,

      mt_columnxl_0: 0,
      columnlg_6: 6,
      columnxl_4: 4,
      columnmd_6: 6,
    },
    {
      field: 'selectBy',
      name: 'Select By',
      isClass: true,
      viewType: 'Radio',
      isEmp: true,
      list: [
        { name: 'Labeler', value: 'Labeler' },
        { name: 'NDC', value: 'NDC' },
        {
          name: 'Select All For Above Criteria',
          value: 'Select All For Above Criteria',
        },
      ],
      // column: 8,
      column: 12,
      column1: 6,
      column2: 8,
      mt_columnlg_3: 3,
      mt_columnxl_0: 0,
      columnlg_12: 12,
      columnxl_8: 8,
      columnmd_6: 6,
    },
    {
      field: 'searchType',
      name: 'Search Type',
      viewType: 'Radio',
      isEmp: true,
      list: [
        { name: 'NDC', value: 'NDC' },
        { name: 'Name', value: 'Name' },
        { name: 'Labeler', value: 'Labeler' },
      ],
      column: 12,
      column1: 6,
      column2: 5,
      mt2: 2,
      sm_pl0: 0,
      md_pl3: 3,
      columnmd_6: 6,
    },
  ];

  const frameworkComponents = {
    drugName: (cellInfo) => {
      const name = cellInfo && cellInfo.value;
      if (name && name.length > 20) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name }</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };

  const filterAction = useCallback(
    (flType, value) => {
      const filterObject = {
        clearPriorAuditsResult: filterValue.clearPriorAuditsResult,
        planType: filterValue.planType,
        rebateProgram: filterValue.rebateProgram,
        searchType: filterValue.searchType,
        selectBy: filterValue.selectBy,
        fromDate: filterValue.fromDate,
        toDate: filterValue.toDate,
      };
      setNdcValidError([]);
      setErrorMessages([]);
      setNdcSearchError([]);
      setSuccessMessages([]);
      if (flType === 'selectBy' && value === 'NDC') {
        setRadioList([...radioList, 'searchType']);
        filterValue.searchType = 'NDC';
      }
      if (
        flType === 'selectBy' &&
        (value === 'Select All For Above Criteria' || value === 'Labeler')
      ) {
        setRadioList(radioList.filter((item) => item !== 'searchType'));
        dispatch(setLeftTableData([]));
        dispatch(setRightTableData([]));
      }
      if (flType === 'selectBy' && value === 'Name') {
        dispatch(setLeftTableData([]));
      }

      if (flType === 'searchType' && value === 'NDC') {
        dispatch(setLeftTableData([]));
      }
      if (
        (flType === 'searchType' && value === 'Name') ||
        value === 'Labeler'
      ) {
        dispatch(setRightTableData([]));
        dispatch(setLeftTableData([]));
      }
      if (flType === 'planType') {
        const plantype =
          value === 'Medicaid' ? 'FD' : value === 'State' ? 'ST' : 'COMM';
        filterObject.rebateProgram = -1;
        setFilterValue({
          ...filterValue,
          rebateProgram: -1,
        });

        getCommonDropdownList(plantype).then((res) => {
          setRebateProgList(res);
        });
      }
      if (flType === 'rebateProgram' && value !== -1) {
        setErrorMessages([]);
      }
      filterObject[flType] = value;
      setNdcsSearch({
        ...ndcsSearch,
        ndcCode: '',
      });
      setFilterValue({
        ...filterValue,
        [flType]: value,
      });
      dispatch(requestClaimFields(filterObject));
    },
    [filterValue, ndcTableData, addListedNdc, ndcsSearch]
  );
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  React.useEffect(() => {
    if (duplicateErrors) {
      setEmptyTableError((prev) => ({
        ...prev,
        ndcLeft: duplicateErrors,
      }));
      setErrorMessages(duplicateErrors);
    }
  }, [duplicateErrors]);

  React.useEffect(() => {
    if (
      userDefaults &&
      !_.isEmpty(userDefaults) &&
      _.isEmpty(getRequestFieldsValue)
    ) {
      let planTypeFil = _.filter(
        filterList,
        (l) => l.field === 'planType' && l.list
      )[0].list;
      planTypeFil = _.filter(
        planTypeFil,
        (l) => l.sortValue === userDefaults.planTypeCd
      );
      dispatch(
        requestClaimFields({
          ...filterValue,
          planType:
            planTypeFil && !_.isEmpty(planTypeFil)
              ? planTypeFil[0].value
              : 'Medicaid',
          rebateProgram: userDefaults.rebateProgramCd
            ? userDefaults.rebateProgramCd
            : -1,
          searchType: userDefaults.defNdcSelectModeCd
            ? userDefaults.defNdcSelectModeCd !== 'NDC'
              ? _.capitalize(userDefaults.defNdcSelectModeCd)
              : userDefaults.defNdcSelectModeCd
            : 'Name',
        })
      );
      const result = getCommonDropdownList(
        planTypeFil && !_.isEmpty(planTypeFil)
          ? planTypeFil[0]?.sortValue
          : 'FD'
      );
      result.then((item) => {
        setRebateProgList(item);
      });
    } else if (getRequestFieldsValue) {
      dispatch(requestClaimFields(getRequestFieldsValue));
      const plantype =
        getRequestFieldsValue?.planType === 'Medicaid'
          ? 'FD'
          : getRequestFieldsValue?.planType === 'State'
          ? 'ST'
          : 'COMM';
      getCommonDropdownList(plantype).then((res) => {
        setRebateProgList(res);
      });
    } else {
      dispatch(requestClaimFields(filterValue));
      getCommonDropdownList('FD').then((res) => {
        setRebateProgList(res);
      });
    }
  }, []);

  React.useEffect(() => {
    if (!_.isEmpty(addRequestClaim)) {
      const FilterObject = {
        clearPriorAuditsResult: 'Yes',
        planType: 'Medicaid',
        rebateProgram: -1,
        searchType: 'NDC',
        selectBy: 'NDC',
        fromDate: '',
        toDate: '',
      };
      if (
        addRequestClaim &&
        addRequestClaim.message === 'SUCESS' &&
        addRequestClaim.status === '001'
      ) {
        setLoading(false);
        setSuccessMessages([addRequestClaim.responseMessage]);
      } else if (addRequestClaim.message === 'NETWORK_ERR') {
        setLoading(false);
        setSuccessMessages([]);
        setErrorMessages([API_TIMEOUT_ERROR]);
      } else {
        const succ_message = addRequestClaim?.message.split('–');
        setErrorMessages([
          `${succ_message[0]} - ${filterValue.fromDate}, ${filterValue.toDate}`,
        ]);
        setLoading(false);
        setSuccessMessages([]);
      }
    }
  }, [addRequestClaim]);

  React.useEffect(() => {
    if (
      (filterValue.searchType === 'Labeler' ||
        filterValue.selectBy === 'Labeler') &&
      labelerState
    ) {
      setLoading(true);
      setLabelerState(false);
      dispatch(getLabelerList());
    }
  }, [filterValue]);

  React.useEffect(() => {
    if (getRequestFieldsValue) {
      setFilterValue(getRequestFieldsValue);
      if (getRequestFieldsValue?.selectBy === 'Select All For Above Criteria')
        setRadioList(radioList.filter((item) => item !== 'searchType'));
    }
  }, [getRequestFieldsValue]);

  React.useEffect(() => {
    if (leftNdcTable) {
      setNdcTableData(leftNdcTable);
    }
    if (rightNdcTable) {
      setAddListedNdc(rightNdcTable);
    }
  }, [leftNdcTable, rightNdcTable, labelerData]);

  React.useEffect(() => {
    if (
      filterValue.searchType === 'NDC'
        ? ndcTableData.length > 0
        : addListedNdc.length > 0
    ) {
      setNdcValidError([]);
      setErrorMessages([]);
      setNdcSearchError([]);
    }
  }, [ndcTableData, addListedNdc, filterValue]);

  React.useEffect(() => {
    if (ndcListFromLabeller) {
      if (ndcListFromLabeller.message === 'SUCESS') {
        setLoading(false);
        if (ndcListFromLabeller.data.length > 0) {
          const arrayOfNDCFromLabeler = [];
          const arrayOfNDCLabForComm = [];
          ndcListFromLabeller.data.map((element) => {
            const obj = {};
            obj.ndc = `${element?.labelerCode}-${element?.productCode}-${element?.packageSize}`;
            obj.drugName = element?.drugName;
            obj.fromExisting = 1;
            arrayOfNDCFromLabeler.push(obj);
            const objForComm = {
              ...element,
              ndc: `${element?.labelerCode}-${element.productCode}-${element.packageSize}`,
            };
            arrayOfNDCLabForComm.push(objForComm);
          });
          dispatch(setLeftTableData(arrayOfNDCLabForComm));
        } else {
          dispatch(setLeftTableData([]));
        }
      }
    }
  }, [ndcListFromLabeller]);

  React.useEffect(() => {
    if (existingLabelerDataFromAPI) {
      if (existingLabelerDataFromAPI.message === 'SUCESS') {
        const arrayOfLabelerList = [];
        existingLabelerDataFromAPI.data.map((element) => {
          const obj = {};
          obj.labelerCode = element.labelerCode;
          obj.labelerName = element.labelerName;
          arrayOfLabelerList.push(obj);
        });
        setExistingLabelerData(
          arrayOfLabelerList.sort(
            (key, value) =>
              parseInt(key.labelerCode) - parseInt(value.labelerCode)
          )
        );
        setLoading(false);
      }
    }
  }, [existingLabelerDataFromAPI]);

  const fetchDetails = async (key, val = false) => {
    const searchByNDCIDSplit = ndcsSearch.ndcCode.split('-');

    if (key === 'ndc' && !val && ndcSearchCode.length) {
      dispatch(setRightTableData([...addListedNdc, ...ndcSearchCode] || []));
      setNdcsSearch((prev) => ({
        ...prev,
      }));
    } else if (
      (key === 'ndc' &&
        searchByNDCIDSplit.length == 1 &&
        searchByNDCIDSplit[0].length === 11) ||
      (key === 'ndc' &&
        searchByNDCIDSplit.length === 3 &&
        searchByNDCIDSplit[0].length === 5 &&
        searchByNDCIDSplit[1].length === 4 &&
        searchByNDCIDSplit[2].length === 2) ||
      (key === 'drugName' && ndcsSearch.ndcCode) ||
      (key === 'ndc' && !val && !ndcSearchCode.length)
    ) {
      setLoading(true);
      const searchResult = await searchNDCByIDORDrugName({
        searchBy: key,
        inputValue: ndcsSearch.ndcCode,
        page: 0,
        pageSize: 1000000000,
      });
      if (val && searchResult?.length > 0) {
        setNdcSearchCode(searchResult);
        setNdcsSearch((prev) => ({
          ...prev,
          ndcCode: `${ndcsSearch.ndcCode} | ${searchResult[0]?.drugName}`,
        }));
      }
      if (
        !val &&
        searchResult?.length > 0 &&
        !ndcSearchCode.length &&
        key !== 'drugName'
      ) {
        if (!addListedNdc.some((obj) => obj.ndc === searchResult[0].ndc)) {
          dispatch(setRightTableData([...addListedNdc, ...searchResult] || []));
        } else {
          setErrorMessages([NDC_ALREADY_ADDED]);
          setNdcValidError([NDC_ALREADY_ADDED]);
        }
      }
      if (!searchResult) {
        setErrorMessages([NDC_NOT_FOUND_STC]);
        setNdcValidError([NDC_NOT_FOUND_STC]);
        setNdcSearchError([NDC_NOT_FOUND_STC]);
      }
      if (key === 'drugName') {
        dispatch(setLeftTableData(searchResult || []));
      }

      setLoading(false);
    } else if (!ndcsSearch.ndcCode || !ndcsSearch.ndcCode.trim()) {
      setErrorMessages([NDC_FOR_UC_NOT]);
      setNdcValidError([NDC_FOR_UC_NOT]);
      setNdcSearchError([NDC_FOR_UC_NOT]);
    } else {
      setNdcValidError([VALID_NDC_MSG_UC]);
      setErrorMessages([VALID_NDC_MSG_UC]);
    }
  };

  const onNDCsFilter = async (type, key) => {
    emptyTableError.ndcLeft = [];
    emptyTableError.ndcRight = [];
    setNdcValidError([]);
    setErrorMessages([]);
    setNdcSearchError([]);

    if (type === 'ndcName') {
      fetchDetails(key);
    } else if (
      type === 'addNdc' &&
      filterValue.selectBy === 'NDC' &&
      filterValue.searchType === 'NDC'
    ) {
      fetchDetails(key);
    } else if (
      type === 'addNdc' &&
      (filterValue.searchType === 'Name' ||
        filterValue.searchType === 'Labeler')
    ) {
      if (selectedRow && selectedRow.length === 0) {
        emptyTableError.ndcLeft = [ERR_SELECT_NDC_REMOVE];
        setErrorMessages([ERR_SELECT_NDC_REMOVE]);
      } else {
        dispatch(
          checkNDCAndAddToDetailsTable(selectedRow, ndcTableData, addListedNdc)
        );
        gridApi.deselectAll();
      }
    }
    setEmptyTableError((prev) => ({
      ...prev,
    }));
  };

  const actionNDCsMove = (key) => {
    emptyTableError.ndcRight = [];
    emptyTableError.ndcLeft = [];

    if (key === 'AllLeftToRight') {
      if (ndcTableData.length == 0) {
        emptyTableError.ndcLeft = [ERRORMESSAGE_NDC_NOT_EMPTY];
      } else {
        setErrorMessages([]);
        dispatch(setMoveAllDatasLefttoRight(ndcTableData, addListedNdc));
        gridApi.deselectAll();
      }
    } else if (key === 'AllRightToLeft') {
      setErrorMessages([]);
      dispatch(setMoveAllDatasRighttoLeft(addListedNdc, ndcTableData));
    } else if (key === 'rightToLeft') {
      if (selectedRow.length > 0) {
        setErrorMessages([]);
        dispatch(
          removeFromNDCDetailsTableData(selectedRow, addListedNdc, ndcTableData)
        );
      } else if (addListedNdc.length === 0) {
        emptyTableError.ndcRight = [ERR_NDC_REMOVE];
        setErrorMessages([ERR_NDC_REMOVE]);
      } else {
        emptyTableError.ndcRight = [ERR_SELECT_NDC_REMOVE];
        setErrorMessages([ERR_SELECT_NDC_REMOVE]);
      }

      setEmptyTableError((prev) => ({
        ...prev,
      }));
    }
  };

  React.useEffect(() => {
    if (rebateProgList && rebateProgList.message === 'SUCESS') {
      let list = [];

      if (!_.isEmpty(rebateProgList?.data)) {
        list = _.map(rebateProgList?.data, (val, ind) => {
          return {
            ...val,
            id: val.rebateProgramCd,
            name: `${val.rebateProgramCd} | ${val.shortDescr}`,
            startQtr: val.startQt,
            endQtr: val.endQtr,
          };
        });
      }
      setRebateProgramList(
        list.sort((key, val) =>
          key.name.toLowerCase().localeCompare(val.name.toLowerCase())
        )
      );
    }
  }, [rebateProgList]);

  const showMoveButtons = () => {
    if (filterValue.selectBy === 'NDC' && filterValue.searchType === 'NDC') {
      return false;
    }
    return true;
  };

  React.useEffect(() => {
    if (labelerSelected) {
      setLoading(true);
      dispatch(
        getNDCByLabeller({
          labelerCode: labelerSelected.labelerCode,
          page: 1,
          pageSize: 1,
        })
      );
      setSelectedRow([]);
      gridApi.deselectAll();
    }
  }, [labelerSelected]);

  const onSelectAction = (key, value) => {
    if (filterValue.selectBy === 'Labeler') {
      dispatch(setRightTableData([value]));
    } else {
      setLabelerData(true);
      setLabelerSelected(value);
    }
    dispatch(setLeftTableData([]));
    dispatch(setRightTableData([]));
  };

  const fullDate = (date, key) => {
    if (date.length === 7) {
      const datearr = date.split('/');
      const month = datearr[0];
      const year = datearr[1];
      const lastDate = new Date(Number(year), Number(month), 0).getDate();
      return `${month}/${key === 'toDate' ? lastDate : '01'}/${year}`;
    }
    return date;
  };

  const runConfirmedApi = () => {
    if (!pendingPayload) return;
  
    setLoading(true);
    setErrorMessages([]);
  
    requestRunNow(pendingPayload)
      .then((response) => {
        dispatch(dispatchRequestClaim(response.data));
      })
      .catch((err) => {
        if (
          err.message === 'Network Error' ||
          err.message === 'Request failed with status code 502'
        ) {
          dispatch(dispatchRequestClaim({ message: 'NETWORK_ERR' }));
        } else {
          dispatch(dispatchRequestClaim(err));
        }
      });
  };
  
  const onRequestRunNow = (key) => {
    let getDate = '';
    let { rebateProgram, searchType, fromDate, toDate, selectBy } = filterValue;
    if (fromDate.length === 7) {
      fromDate = fullDate(fromDate, 'fromDate');
    }
    if (toDate.length === 7) {
      toDate = fullDate(toDate, 'toDate');
    }
    const getDateFormat = (data, key) => {
      if (data.charAt(1) === 'Q') {
        if (data.length === 6) {
          return DateRangeValidation(data, key, true);
        }
        if (data.length === 4) {
          return DateRangeValidation(data, key, false);
        }
      } else {
        return moment(data).format('MM/DD/YYYY');
      }
    };
    if (!formError.fromDate && fromDate !== '' && toDate === '') {
      let startFromDate = fromDate;
      if (fromDate.charAt(1) === 'Q') {
        if (fromDate.length === 6) {
          startFromDate = DateRangeValidation(fromDate, 'fromDate', true);
        } else if (fromDate.length === 4) {
          startFromDate = DateRangeValidation(fromDate, 'fromDate', false);
        }
      }
      const getlastMonth = (month) => {
        if (month == 1 || month == 2 || month == 3) return 3;
        if (month == 4 || month == 5 || month == 6) return 6;
        if (month == 7 || month == 8 || month == 9) return 9;
        if (month == 10 || month == 11 || month == 12) return 12;
      };
      const month = getlastMonth(new Date(startFromDate).getMonth() + 1);
      const year = new Date(startFromDate).getFullYear();
      const lastDate = new Date(Number(year), Number(month), 0).getDate();
      getDate = `${month}/${lastDate}/${year}`;
      setFilterValue((prev) => ({
        ...prev,
        toDate: getDate,
      }));
    }
  
    const payload = {
      startDate: getDateFormat(fromDate, 'fromDate'),
      endDate: getDateFormat(
        filterValue.toDate !== '' ? toDate : getDate,
        'toDate'
      ),
      rebetProgramCd: filterValue.rebateProgram,
      clearPriorAudit: filterValue.clearPriorAuditsResult,
      selectByLabeler:
        filterValue.selectBy === 'Labeler'
          ? (selectedRow.length > 0 && selectedRow[0]?.labelerCode) || ''
          : null,
      selectByAll:
        filterValue.selectBy === 'Select All For Above Criteria' ? 'Yes' : 'No',
      ndcSearchCriteriaVOList: selectBy !== 'Labeler' ? addListedNdc || [] : [],
      runProcessOption: key,
      userName: logInUserID ? logInUserID : logInUser,
    };
    const errorMsg = [
      PAID_DATE_ERR,
      TO_DATE_CANT_BE_LESS_THAN_FROM,
      REBATE_SELECT,
      ERRMSG_NO_NDC_REQUEST_CLAIM_AUDIT,
      ERRMSG_NOT_SELECTED_LABELER,
    ];
    let errorList = [];
    errorList = errorMsg.filter((data) => {
      switch (data) {
        case PAID_DATE_ERR:
          if (fromDate === '') {
            formError.fromDate = true;
            formErrMsg.fromDate = PAID_DATE_ERR;
            return PAID_DATE_ERR;
          }
          return;
        case REBATE_SELECT:
          if (!rebateProgram || rebateProgram === -1 || rebateProgram === '-1') {
            return REBATE_SELECT;
          }
          return;
        case ERRMSG_NO_NDC_REQUEST_CLAIM_AUDIT:
          if (
            (selectBy === 'NDC' &&
              addListedNdc.length === 0 &&
              searchType !== 'Labeler') ||
            ((selectBy === 'Labeler' || searchType === 'Labeler') &&
              addListedNdc.length === 0 &&
              ndcTableData.length !== 0)
          ) {
            return ERRMSG_NO_NDC_REQUEST_CLAIM_AUDIT;
          }
          return;
        case ERRMSG_NOT_SELECTED_LABELER:
          if (
            (searchType === 'Labeler' &&
              selectBy === 'NDC' &&
              addListedNdc.length === 0 &&
              ndcTableData.length === 0) ||
            (selectBy === 'Labeler' && selectedRow.length === 0)
          ) {
            return ERRMSG_NOT_SELECTED_LABELER;
          }
        case TO_DATE_CANT_BE_LESS_THAN_FROM:
          if (fromDate && toDate) {
            const startDate = new Date(getDateFormat(fromDate, 'fromDate'));
            const endDate = new Date(getDateFormat(toDate, 'toDate'));
            if (startDate > endDate) {
              formError.fromDate = true;
              return TO_DATE_CANT_BE_LESS_THAN_FROM;
            }
          }
          return;
        default:
          return null;
      }
    });
    setErrorMessages(errorList);
    if (errorList.length === 0) {
      let finalList = payload.ndcSearchCriteriaVOList;
      if (finalList.length > 1000) {
        finalList = finalList.slice(0, 1000);
        const updatedPayload = { ...payload, ndcSearchCriteriaVOList: finalList };
        setPendingPayload(updatedPayload);
        setConfirmAction(true);
        return;
      }
      setLoading(true);
      setErrorMessages([]);
      requestRunNow(payload)
        .then((response) => {
          dispatch(dispatchRequestClaim(response.data));
        })
        .catch((err) => {
          if (
            err.message === 'Network Error' ||
            err.message === 'Request failed with status code 502'
          ) {
            dispatch(dispatchRequestClaim({ message: 'NETWORK_ERR' }));
          } else {
            dispatch(dispatchRequestClaim(err));
          }
        });
    } else {
      handleScrollToEvent();
    }
    
    
  };
  const changeFullScreenView = (tableName) => {
    const view = !fullScreenView;
    setFullScreenView(view);
    setFullScreenViewTable(view ? tableName : null);
  };

  const handleDateChange = (key, val) => {
    formError.fromDate = false;
    formError.toDate = false;
    formErrMsg.toDate = '';
    formErrMsg.fromDate = '';
    setErrorMessages([]);
    setSuccessMessages([]);
    const data = val;
    const filterObject = filterValue;
    filterObject[key] = data;
    dispatch(requestClaimFields(filterObject));
    setFilterValue({
      ...filterValue,
      [key]: data,
    });
  };

 const onBlurDateChange = (key, val) => {
  const input = val?.toUpperCase();
  let formatted = autoFormateDate(input); // e.g., "1Q2024"

  // Handle quarter-year format like "1Q2024"
  const quarterMatch = /^([1-4]Q)(\d{4})$/.exec(formatted);
  if (quarterMatch) {
    const [_, quarter, year] = quarterMatch;
    const incrementedYear = parseInt(year, 10);
    formatted = `${quarter}${incrementedYear}`; // Optional: only if increment is needed
  }

  const isQuarterFormat = /^([1-4]Q)\d{4}$/.test(formatted);
  const isMonthFormat = /^(\d{1,2})\/(\d{4})$/.test(formatted);
  const isDateFormat = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/.test(formatted);

  let errorMsg = null;

  // Format validation
  if (!isQuarterFormat && !isMonthFormat && !isDateFormat) {
    errorMsg = REQUEST_DATE_INVALID_FORMAT;
  }
 const getDateFormat = (data, key) => {
      if (data.charAt(1) === 'Q') {
        if (data.length === 6) {
          return DateRangeValidation(data, key, true);
        }
        if (data.length === 4) {
          return DateRangeValidation(data, key, false);
        }
      } else {
        return moment(data).format('MM/DD/YYYY');
      }
    };
  // Range validation
  const from = key === 'fromDate' ? formatted : filterValue.fromDate;
  const to = key === 'toDate' ? formatted : filterValue.toDate;

  if (from && to) {
    const start = new Date(getDateFormat(from, 'fromDate'));
    const end = new Date(getDateFormat(to, 'toDate'));
    if (start > end) {
      errorMsg = TO_DATE_CANT_BE_LESS_THAN_FROM;
    }
  }

  // Minimum date check
  const minDate = new Date(MINIMUM_START_DATE_VALUE);
  const currentDate = new Date(getDateFormat(formatted, key));
  if (currentDate < minDate) {
    errorMsg = MINIMUM_FORM_DATE;
  }

  // Apply error or update state
  if (errorMsg) {
    formError[key] = true;
    formErrMsg[key] = errorMsg;
    setErrorMessages([errorMsg]);
  } else {
    formError[key] = false;
    formErrMsg[key] = '';
    setErrorMessages([]);
    setFilterValue(prev => ({
      ...prev,
      [key]: formatted,
      ...(key === 'fromDate' && !prev.toDate ? { toDate: formatted } : {})
    }));
  }
};

  const handleNdc = useCallback(
    (key, data) => {
      setNdcValidError([]);
      setErrorMessages([]);
      setNdcSearchError([]);
      let value = data;
      if (
        filterValue.selectBy === 'NDC' &&
        filterValue.searchType === 'NDC' &&
        key === 'ndcCode'
      ) {
        if (value.length === 5 || value.length === 10) {
          value = `${data}-`;
        } else {
          value = data;
        }
      }
      setNdcsSearch({
        ...ndcsSearch,
        [key]: value,
      });
    },
    [ndcsSearch]
  );

  const handleKey = (event) => {
    if (event.key === 'Backspace') {
      let value =
        ndcsSearch?.ndcCode?.charAt(ndcsSearch?.ndcCode.length - 1) === '-'
          ? ndcsSearch?.ndcCode?.slice(0, -1)
          : ndcsSearch.ndcCode;
      setNdcsSearch({
        ...ndcsSearch,
        ['ndcCode']: value,
      });
    }
    if (event.key === 'Enter') onNDCsFilter('addNdc', 'ndc');
  };

  const handleBlur = (fType, e) => {
    const errorMessageForNDC = errorMessages;
    if (e.target.value) {
      const seVal = e.target.value;
      const regexP = /^[\^A-Za-z0-9]{5}-[\^A-Za-z0-9]{4}-[\^A-Za-z0-9]{2}$/;

      // eslint-disable-next-line eqeqeq
      if (seVal.length != 13 || !regexP.test(seVal)) {
        setNdcValidError([NDC_CODE_FOR_STC_NOT]);
        setErrorMessages([NDC_CODE_FOR_STC_NOT]);
        setNdcSearchError([NDC_CODE_FOR_STC_NOT]);
      }
    }
  };

  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const checkError = () => {
      if (errorMessages.length > 0) return true;
      if (ndcValidError.length > 0) return true;
      return false;
    };

    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/RequestClaimAudit') {
          if (checkError()) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages, ndcValidError, emptyTableError, formErrMsg]);

  React.useEffect(() => {
    const obj = {};
    obj.errorMessages = errorMessages;
    obj.ndcValidError = ndcValidError;
    obj.emptyTableError = {
      labelerTable: emptyTableError.labelerTable,
      ndcLeft: emptyTableError.ndcLeft,
      ndcRight: emptyTableError.ndcRight,
    };
    obj.formErrMsg = {
      fromDate: formErrMsg.fromDate,
      toDate: formErrMsg.toDate,
    };
    obj.ndcSearchError = ndcSearchError;
    dispatch(requestClaimErrors(obj));
  }, [
    errorMessages,
    ndcValidError,
    emptyTableError,
    formErrMsg,
    ndcSearchError,
  ]);

  React.useEffect(() => {
    if (getRequestFieldsErrors) {
      const { errorMessages, ndcValidError, emptyTableError, formErrMsg } =
        getRequestFieldsErrors;
      setErrorMessages(errorMessages);
      setNdcValidError(ndcValidError);
      setEmptyTableError((prev) => ({
        ...prev,
        labelerTable: emptyTableError.labelerTable,
        ndcLeft: emptyTableError.ndcLeft,
        ndcRight: emptyTableError.ndcRight,
      }));
      setFormErrMsg((prev) => ({
        ...prev,
        fromDate: formErrMsg.fromDate,
        toDate: formErrMsg.toDate,
      }));
      setFormError((prev) => ({
        ...prev,
        fromDate: formErrMsg.fromDate.length > 0,
        toDate: formErrMsg.toDate.length > 0,
      }));
    }
  }, []);
  return (
    <>
      <div
        className="tabs-container frr-request-claim-audit"
        data-testid="RequestClaimAuditComp"
      >
        <Spinner load={loading} />
        <CustomSeparator parent1="Tasks" parent2="Request Claim Audits" />
        <DisplaySuccessMessages successMessages={successMessages} />
        <DisplayErrorMessages errorMessages={errorMessages || []} />
        {!fullScreenView && (
          <div className="tab-body custom-search-dates">
            <div className="row mb-2">
              <div className="col-12 col-sm-6 col-md-4 mb-3 col-lg-4 col-xl-4">
                <fieldset className="custom-fieldset">
                  <legend>
                    Paid date/Qtr. Range
                    <span className="mandatory"> *</span>
                  </legend>
                  <div className="row">
                    <div className="col-sm-12">
                      <div
                        className="mui-zip-flex"
                        style={{ display: 'contents' }}
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="mui-custom-textField input-md w-100">
                              <TextField
                                className="mandate-fields"
                                label="From"
                                id="from-req"
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 10, id: 'from-req' }}
                                value={filterValue.fromDate}
                                data-testid="paidDateRange"
                                onChange={(date) => {
                                  handleDateChange(
                                    'fromDate',
                                    date.target.value
                                  );
                                }}
                                helperText={
                                  formError.fromDate
                                    ? formErrMsg.fromDate
                                    : null
                                }
                                error={
                                  formError.fromDate ? formError.fromDate : null
                                }
                                onBlur={(e) =>
                                  onBlurDateChange('fromDate', e.target.value)
                                }
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="mui-custom-textField input-md w-100">
                              <TextField
                                className="mandate-fields"
                                label="To"
                                id="to-req"
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 10, id: 'to-req' }}
                                value={filterValue.toDate}
                                data-testid="toDate"
                                onChange={(event) => {
                                  handleDateChange(
                                    'toDate',
                                    event.target.value
                                  );
                                }}
                                helperText={
                                  formError.toDate ? formErrMsg.toDate : null
                                }
                                error={
                                  formError.toDate ? formError.toDate : null
                                }
                                onBlur={(e) =>
                                  onBlurDateChange(
                                    'toDate',
                                    e.target?.value?.toUpperCase()
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              {!_.isEmpty(filterList)
                ? filterList?.map(
                    (val, ind) =>
                      !_?.includes(viewFilter, val.field) && (
                        <div
                          className={`col-${val.column} col-sm-${
                            val.column1
                          }  ${val.mt2 ? `mt-${val?.mt2}` : ''}  ${
                            val?.md_mt2 ? `mt-md-${val?.md_mt2}` : ''
                          } ${val?.sm_pl0 == 0 ? `pl-sm-${val?.sm_pl0}` : ''}${
                            val?.md_pl3 == 3 ? `pl-md-${val?.sm_pl0}` : ''
                          } 
                         ${val?.md_lg3 == 3 ? `pl-md-${val?.lg_pl3}` : ''} 
 
                         ${
                           val?.columnxl_3 == 3
                             ? `col-xl-${val?.columnxl_3}`
                             : ''
                         }
                         
                         ${
                           val?.mt_columnlg_3 == 3
                             ? `mt-lg-${val?.mt_columnlg_3}`
                             : ''
                         } 
                         ${
                           val?.mt_columnxl_0 == 0
                             ? `mt-xl-${val?.mt_columnxl_0}`
                             : ''
                         } 
                         
                         
                         
                         
                         ${
                           val?.columnlg_4 == 4
                             ? `col-lg-${val?.columnlg_4}`
                             : ''
                         }
                         ${
                           val?.columnlg_6 == 6
                             ? `col-lg-${val?.columnlg_6}`
                             : ''
                         }
                         ${
                           val?.columnlg_8 == 8
                             ? `col-lg-${val?.columnlg_8}`
                             : ''
                         }
                         ${
                           val?.columnlg_12 == 12
                             ? `col-lg-${val?.columnlg_12}`
                             : ''
                         }
                         
 
                         ${
                           val?.columnxl_4 == 4
                             ? `col-xl-${val?.columnxl_4}`
                             : ''
                         }
                         ${
                           val?.columnxl_5 == 5
                             ? `col-xl-${val?.columnxl_5}`
                             : ''
                         } 
                         ${
                           val?.columnxl_8 == 8
                             ? `col-xl-${val?.columnxl_8}`
                             : ''
                         } 
 
                         ${
                           val?.columnmd_4 == 4
                             ? `col-md-${val?.columnmd_4}`
                             : ''
                         }
                         ${
                           val?.columnmd_6 == 6
                             ? `col-md-${val?.columnmd_6}`
                             : ''
                         }
                         ${
                           val?.columnmd_8 == 8
                             ? `col-md-${val?.columnmd_8}`
                             : ''
                         }
                         ${
                           val?.columnmd_12 == 12
                             ? `col-md-${val?.columnmd_12}`
                             : ''
                         }
 
                          
                         
                     
                         
                         
                          
 
 
 
 
                         ${val?.pl0 == 0 ? `pl-${val?.pl0}` : ''} ${
                            val.isClass ? ' mt-2 mb-2' : ''
                          } ${
                            ['clearPriorAuditsResult', 'planType'].includes(
                              val.field
                            ) && 'optionCenter'
                          } `}
                          key={val.field}
                        >
                          {val?.viewType === 'SelectBox' ? (
                            <div className="frr-height-83">
                              <SelectBoxComponent
                                id="RebateSelect"
                                label="Rebate Program"
                                labelName={_.startCase(val.field)}
                                required={val.isEmp}
                                optionList={rebateProgramList || []}
                                defaultValue={filterValue?.rebateProgram}
                                data-testid="selectInput"
                                filterAction={(e) => filterAction(val.field, e)}
                              />
                            </div>
                          ) : (
                            <div>
                              {radioList.includes(val?.field) && (
                                <RadioGroupComponent
                                  labelName={_.startCase(val?.field)}
                                  required={val.isEmp}
                                  optionList={val.list || []}
                                  defaultValue={filterValue[val.field]}
                                  filterAction={(e) =>
                                    filterAction(val.field, e)
                                  }
                                  reqColor={val.isEmp}
                                  data-testid={`radioInput${val.field}`}
                                />
                              )}
                            </div>
                          )}
                        </div>
                      )
                  )
                : null}
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 mb-4 mt-4">
                <div className="btn-wrapper">
                  <CustomButton
                    btnWidthCss="frr-btn-width-125"
                    btnTitle="Run&nbsp;Later"
                    icon="Icon-run-later"
                    onClick={() => onRequestRunNow('L')}
                  />
                  <CustomButton
                    btnTitle=" Run Now"
                    icon="Icon-run-now"
                    onClick={() => onRequestRunNow('N')}
                    data-testid="runnow"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {((filterValue?.selectBy === 'NDC' &&
          filterValue?.searchType === 'Labeler') ||
          filterValue?.selectBy === 'Labeler') && (
          <>
            <DisplayErrorMessages errorMessages={emptyTableError || []} />
            <TableComponent
              setSelectedRow={setSelectedRow}
              searchByDrugNameTableData={existingLabelerData}
              gridApi={gridApiLab}
              setGridApi={setGridApiLab}
              fileName="Request claim audit_Labeler"
              gridHeight={fullScreenView ? '70vh' : 400}
              columnName={labelerTableHead}
              rowSelection="multiple"
              fullScreenView={fullScreenView}
              onSelect={(e) => onSelectAction('labeler', e.data)}
              applyFilter={applyFilter}
              emptyTableError={emptyTableError.labelerTable}
              handleFullScreenView
              handleFullScreenViewClick={changeFullScreenView}
              exportFile
              data-testid="labeler-table"
            />
          </>
        )}
        <div className="FRR-custom-table">
          {filterValue.searchType === 'Name' &&
            !(filterValue.selectBy === 'Labeler') &&
            !(filterValue.selectBy === 'Select All For Above Criteria') && (
              <div className="tab-header display-inline-flex">
                <div className="selectedByName">
                  <TextField
                    id="standard-reason-code"
                    label="Search"
                    InputLabelProps={{ shrink: true }}
                    placeholder="Search..."
                    variant="outlined"
                    className="searchInput frr-display-hidden-label"
                    inputProps={{ id: 'standard-reason-code' }}
                    value={ndcsSearch.ndcCode}
                    onChange={(e) => handleNdc('ndcCode', e.target.value)}
                    data-testid="RequestClaim-search-by-ndc"
                  />
                  <div className="float-right btn-wrapper pt-1" tabIndex={0}>
                    <Button
                      className="btn btn-success btn-search ml-1"
                      onClick={() => onNDCsFilter('ndcName', 'drugName')}
                      data-testid="ndc-search-btn"
                    >
                      <SVGComponent iconName="Icon-search" />
                      {'  '} Search
                    </Button>
                  </div>
                  <DisplayErrorMessages errorMessages={ndcSearchError || []} />
                </div>
              </div>
            )}

          {filterValue?.selectBy == 'NDC' && (
            <div className="row row_wrp">
              <div className="request_task_box1">
                {filterValue.selectBy === 'NDC' &&
                filterValue.searchType === 'NDC' ? (
                  <div className="ndcsTableSection">
                    <div className="ndcTable ndcTableLeft col-12">
                      <div className="selectedByNDCs">
                        <label
                          className="ndcLabel"
                          htmlFor="standard-reason-code"
                        >
                          Enter NDC to be added
                        </label>
                        <TextField
                          id="standard-reason-code"
                          data-testid="ndc-search-input"
                          placeholder="XXXXX-XXXX-XX"
                          variant="outlined"
                          className="searchInput"
                          value={ndcsSearch.ndcCode}
                          onBlur={(e) => handleBlur('onBlur', e)}
                          inputProps={{
                            maxLength: 13,

                            id: 'standard-reason-code',
                          }}
                          onChange={(e) => handleNdc('ndcCode', e.target.value)}
                          onKeyDown={handleKey}
                        />
                        <DisplayErrorMessages
                          errorMessages={ndcValidError || []}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="frr-ndc-left-table">
                    <TableComponent
                      setSelectedRow={setSelectedRow}
                      searchByDrugNameTableData={ndcTableData}
                      gridApi={gridApi}
                      setGridApi={setGridApi}
                      columnName={NDCTableHead}
                      rowSelection="multiple"
                      emptyTableError={emptyTableError.ndcLeft}
                      frameworkComponents={frameworkComponents}
                      fullScreenView={fullScreenView}
                      fileName="Request Claim Audit- NDC"
                      handleFullScreenView
                      handleFullScreenViewClick={changeFullScreenView}
                      exportFile
                      data-testid="ndcLeft-table"
                    />
                  </div>
                )}
              </div>
              <div className="ndcsTableSection task_request_claim">
                <div className="ndcTableBtn">
                  <Button
                    className="btn-primary"
                    onClick={() => onNDCsFilter('addNdc', 'ndc')}
                    aria-label="single data forward"
                    data-testid="excludedNDCs-move-left-to-right-list-btn"
                    tabIndex={0}
                  >
                    <i
                      className="fa fa-light fa-caret-right"
                      aria-hidden="true"
                    />
                  </Button>
                  {showMoveButtons() && (
                    <Button
                      className="btn-primary"
                      onClick={() => actionNDCsMove('AllLeftToRight')}
                      aria-label="All data forward"
                      data-testid="excludedNDCs-move-left-to-right-all-list-btn"
                      tabIndex={0}
                    >
                      <i
                        className="fa fa-light fa-forward"
                        aria-hidden="true"
                      />
                    </Button>
                  )}
                  {showMoveButtons() && (
                    <Button
                      className="btn-primary"
                      onClick={() => actionNDCsMove('AllRightToLeft')}
                      aria-label="All data backward"
                      data-testid="excludedNDCs-move-right-to-left-all-list-btn"
                      tabIndex={0}
                    >
                      <i
                        className="fa fa-light fa-backward"
                        aria-hidden="true"
                      />
                    </Button>
                  )}
                  <Button
                    className="btn-primary"
                    onClick={() => actionNDCsMove('rightToLeft')}
                    aria-label="single data backward"
                    data-testid="excludedNDCs-move-right-to-left-list-btn"
                    tabIndex={0}
                  >
                    <i
                      className="fa fa-light fa-caret-left"
                      aria-hidden="true"
                    />
                  </Button>
                </div>
              </div>
              <div className="request_task_box2">
                <TableComponent
                  setSelectedRow={setSelectedRow}
                  searchByDrugNameTableData={addListedNdc || []}
                  gridApi={gridApis}
                  setGridApi={setGridApis}
                  columnName={NDCTableHead}
                  rowSelection="multiple"
                  emptyTableError={emptyTableError.ndcRight}
                  fullScreenView={fullScreenView}
                  frameworkComponents={frameworkComponents}
                  handleFullScreenView
                  handleFullScreenViewClick={changeFullScreenView}
                  fileName="Request Claim Audit- NDC"
                  exportFile
                />
              </div>
              <CommonModal
                open={confirmAction}
                viewAction
                className="dialog-420"
                viewHeader
                modalTitle="Confirmation Dialog"
                okTitle="Yes"
                closeTitle="No"
                childrenComponent={NDC_LIMIT_TO_1000}
                onClose={() => {
                  setConfirmAction(false);
                }}
                onOk={() => {
                  setConfirmAction(false);
                  runConfirmedApi();
                }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RequestClaimAudit;
